import SummaryApi from "../common";

export const getEmployeeImageUrl = (path) => {
    if (!path) return null;
    const base = String(SummaryApi.employeeImage.url).replace(/\/+$/, "");
    const clean = String(path).replace(/^\/+/, "");
    return `${base}/${clean}`;
};